export default __webpack_public_path__ + "static/media/main_L_right_bg.222ac2a9.png";